import React from "react";
import styled from "styled-components/native";
import { Pressable } from "react-native";
import VDBIcon from "@components/icons/VDBIcon";
import { IconsVariant } from "@components/icons/VDBIcon";
import { useTheme } from "styled-components/native";
import { VDBIcons } from "@utils/VDBIcons";
import { OptionsComponentForBulkRequestEditTypes } from "../SearchResultListItem/types";
import { css } from "styled-components/native";
import { useOrderCart } from "@redux/slices/globalSlice";

const OptionsComponentForBulkRequestEdit = ({
  mItem,
  changeEditCommentModalIndex,
  orderCart = false,
  fromModifyScreen = false,
  stoneItem1,
  isBuilderItem,
  stoneItem2,
  testID,
  dataTestId,
}: OptionsComponentForBulkRequestEditTypes) => {
  const theme = useTheme();
  const orderCartBin = useOrderCart().bin_icon;

  return (
    <OptionsContainer orderCart={orderCart}>
      <Pressable
        testID={testID}
        data-testId={dataTestId}
        onPress={() =>
          changeEditCommentModalIndex(
            isBuilderItem && stoneItem2?.id
              ? [mItem?.id, stoneItem1?.id, stoneItem2?.id]
              : isBuilderItem && !stoneItem2?.id
              ? [mItem?.id, stoneItem1?.id]
              : [mItem?.id]
          )
        }
      >
        {orderCart && !fromModifyScreen ? (
          orderCartBin?.icon?.type === "font" ? (
            <VDBIcon
              color={theme["core-06"]}
              size={24}
              variant={IconsVariant.VDBCustom}
              name={orderCartBin?.icon?.data}
            />
          ) : orderCartBin?.icon?.type === "url" ? (
            <VDBIcon
              name={undefined}
              variant={IconsVariant.CustomUrl}
              uri={orderCartBin?.icon?.data}
              size={24}
              color={theme["core-06"]}
            />
          ) : (
            <VDBIcon
              color={theme["core-06"]}
              size={24}
              variant={IconsVariant.VDBCustom}
              name={VDBIcons.TRASH}
            />
          )
        ) : (
          <VDBIcon
            color={theme["core-06"]}
            size={24}
            variant={IconsVariant.VDBCustom}
            name={VDBIcons.EDIT}
          />
        )}
      </Pressable>
    </OptionsContainer>
  );
};

const OptionsContainer = styled.View<{
  orderCart: boolean;
}>`
  width: 24px;
  justify-content: space-between;
  margin-right: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  ${({ orderCart }: { orderCart: boolean }) =>
    !orderCart &&
    css`
      position: absolute;
      right: 0;
    `}
`;

export default React.memo(OptionsComponentForBulkRequestEdit);
